import type { APIImageType } from '@types';
import qs from 'qs';

import { unstableCachedFetch } from './unstable-cached-fetch';

export async function getAsset(
  docId: string | undefined,
  options?: {
    assetMeta?: boolean;
    tags?: string[];
  },
) {
  if (!docId) return null;

  const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;

  const query = {
    assetMeta: options?.assetMeta || true,
  };

  const url = `${baseUrl}/api/assets/${docId}?${qs.stringify(query, {
    encodeValuesOnly: true,
    arrayFormat: 'comma',
  })}`;

  const headers = new Headers({
    'x-24-org': process.env.NEXT_PUBLIC_API_KEY || '',
  });

  const data = await unstableCachedFetch<APIImageType | Array<APIImageType>>({
    headers,
    tags: options?.tags,
    url,
  });

  return data;
}
